const AvailableStocksToInvestData = [
    {
        stockName: 'XP1',
        qtdAvailable: 1,
        lotValue: 100,
    },
    {
        stockName: 'XP2',
        qtdAvailable: 1,
        lotValue: 200,
    },

    {
        stockName: 'XP3',
        qtdAvailable: 1,
        lotValue: 300,
    },
    {
        stockName: 'XP4',
        qtdAvailable: 1,
        lotValue: 400,
    },
];

export default AvailableStocksToInvestData;
